<template>
  <div class="telegram-menus-host">
    <!-- Group Menu -->
    <div v-if="groupMenu.open" class="telegram-popover-menu group-menu open" :style="{ left: groupMenu.x + 'px', top: groupMenu.y + 'px' }">
      <button class="telegram-popover-item" type="button" @click="groupAction('invite')">邀请新成员</button>
      <button class="telegram-popover-item" type="button" @click="openMemberManager">群成员管理</button>
      <button class="telegram-popover-item" type="button" @click="groupAction('topic')">创建新话题</button>
      <button v-if="isCurrentAdmin" class="telegram-popover-item" type="button" @click="groupAction('rename')">修改群名称</button>
      <button v-if="currentSessionHasMultipleTopics && !isCurrentTopicDefault" class="telegram-popover-item popover-danger" type="button" @click="groupAction('exit-topic')">关闭话题</button>
      <button class="telegram-popover-item popover-danger" type="button" @click="groupAction('exit')">退出群聊</button>
      <button v-if="isCurrentAdmin && isCurrentGroup" class="telegram-popover-item popover-danger" type="button" @click="showDismiss">解散群聊</button>
    </div>

    <!-- Reply Menu -->
    <div v-if="replyMenu.open" ref="replyMenuEl" class="telegram-popover-menu reply-menu open" :style="{ left: replyMenu.x + 'px', top: replyMenuTop + 'px' }">
      <button class="telegram-popover-item reply" type="button" @click="doReply">
        <svg viewBox="0 0 24 24" fill="none"><path d="M9 10L4 15l5 5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/><path d="M4 15h9a7 7 0 0 1 7 7" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
        引用回复
      </button>
      <button class="telegram-popover-item" type="button" @click="openForward">
        <svg viewBox="0 0 24 24" fill="none"><path d="M15 14l5-5-5-5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/><path d="M20 9H9a7 7 0 0 0-7 7" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
        转发
      </button>
      <button class="telegram-popover-item" type="button" @click="copyMessage">
        <svg viewBox="0 0 24 24" fill="none"><rect x="9" y="9" width="13" height="13" rx="2" stroke="currentColor" stroke-width="1.8"/><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1" stroke="currentColor" stroke-width="1.8"/></svg>
        复制文本
      </button>
      <button v-if="replyMenu.clickedImageUrl" class="telegram-popover-item" type="button" @click="copyImage">
        <svg viewBox="0 0 24 24" fill="none"><rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" stroke-width="1.8"/><circle cx="9" cy="9" r="2" stroke="currentColor" stroke-width="1.8"/><path d="M21 15l-5-5L5 21" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
        复制图片
      </button>
      <button v-if="replyMenu.clickedFileUrl" class="telegram-popover-item" type="button" @click="downloadFile">
        <svg viewBox="0 0 24 24" fill="none"><path d="M12 3v12m0 0l-4-4m4 4l4-4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/><path d="M5 21h14" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>
        下载文件
      </button>
      <button class="telegram-popover-item" type="button" @click="togglePin">
        <svg viewBox="0 0 24 24" fill="none"><path d="M12 2v8M9 4l3 3 3-3" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/><path d="M5 12h14M8 12v4a4 4 0 008 0v-4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
        {{ isCurrentMessagePinned ? '取消置顶' : '置顶消息' }}
      </button>
      <button class="telegram-popover-item" type="button" @click="enterMultiSelect">
        <svg viewBox="0 0 24 24" fill="none"><path d="M9 11l3 3L22 4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/><path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
        多选
      </button>
    </div>

    <!-- Emoji Menu -->
    <div v-if="emojiMenu.open" class="telegram-popover-menu emoji-menu open" :style="{ left: emojiMenu.x + 'px', top: emojiMenu.y + 'px' }">
      <button v-for="emoji in emojiList" :key="emoji" class="telegram-popover-item emoji" type="button" :title="emojiName(emoji)" @click="insertEmoji(emoji)">{{ emoji }}</button>
    </div>

    <!-- Mention Menu -->
    <div
      v-if="mentionMenu.open && mentionMenu.members.length"
      ref="mentionEl"
      class="telegram-popover-menu mention-menu open"
      :style="mentionStyle"
    >
      <button
        v-for="(m, idx) in mentionMenu.members"
        :key="m.name"
        class="telegram-popover-item mention"
        :class="{ active: idx === activeIndex }"
        :ref="'mentionItem' + idx"
        type="button"
        @mouseenter="$store.commit('SET_MENTION_ACTIVE_INDEX', idx)"
        @click="insertMention(m.name)"
      >
        <div class="telegram-popover-avatar" :style="{ background: m.avatarUrl ? 'transparent' : (m.avatarBackground || '') }">
          <img v-if="m.avatarUrl" :src="m.avatarUrl" alt="" />
          <template v-else>{{ m.avatarText || (m.name || '?').slice(0, 1) }}</template>
        </div>
        <div class="telegram-popover-copy">
          <div class="telegram-popover-title">@{{ m.name }}</div>
          <div class="telegram-popover-sub">{{ m.sub || '群成员' }}</div>
        </div>
        <span v-if="m.type === 'agent'" class="telegram-mention-ai-tag">AI</span>
      </button>
    </div>

    <!-- 群成员管理弹窗 -->
    <div v-if="memberManagerOpen" class="mm-overlay" @click.self="memberManagerOpen = false">
      <div class="mm-dialog">
        <div class="group-dialog-head">
          <div class="group-dialog-title">群组空间 · {{ currentSessionName }}</div>
          <button class="group-dialog-close" type="button" @click="memberManagerOpen = false">&times;</button>
        </div>
        <input class="group-dialog-search" type="text" v-model="memberManagerQuery" placeholder="搜索成员" />
        <div class="group-dialog-note">当前群内:{{ memberManagerUserCount }}位成员,{{ memberManagerAgentCount }}个AGENT</div>
        <div class="group-dialog-member-list">
          <template v-if="filteredManagerMembers.length">
            <div v-for="m in filteredManagerMembers" :key="m.id" class="group-dialog-member">
              <div class="group-dialog-member-main">
                <div class="group-dialog-member-avatar" :style="{ background: m.avatarUrl ? 'transparent' : (m.avatarBackground || '') }">
                  <img v-if="m.avatarUrl" :src="m.avatarUrl" alt="" />
                  <template v-else>{{ m.avatarText }}</template>
                </div>
                <div class="group-dialog-member-copy">
                  <div class="group-dialog-member-name">
                    {{ m.name }}
                    <span v-if="m.isOwner" class="member-manager-owner-tag">群主</span>
                    <span v-if="m.type === 'agent'" class="member-manager-ai-tag">Agent</span>
                  </div>
                  <div class="group-dialog-member-sub">{{ m.type === 'agent' ? ('负责人：' + (m.ownerName || '—')) : m.isSelf ? '我自己' : m.isOwner ? '管理员' : '群成员' }}</div>
                </div>
              </div>
              <div class="member-manager-actions">
                <button v-if="!m.isSelf && (m.type !== 'agent' || m.ownerId === $store.state.currentUserId)" class="group-dialog-inline-btn" type="button" @click="enterChat(m)">进入会话</button>
                <button v-if="isCurrentAdmin && (m.type === 'agent' || !m.isSelf)" class="group-dialog-inline-btn member-manager-remove-btn" type="button" @click="removeMember(m)">移除</button>
              </div>
            </div>
          </template>
          <div v-else class="group-dialog-empty">暂无匹配成员</div>
        </div>
        <div class="mm-foot">
          <button class="group-dialog-btn primary" type="button" @click="memberManagerOpen = false">完成</button>
        </div>

      </div>
    </div>

    <!-- 移除确认弹窗 -->
    <div v-if="removeConfirmOpen" class="mm-overlay" @click.self="cancelRemove">
      <div class="mm-dialog" style="max-height:auto;">
        <div class="group-dialog-head">
          <div class="group-dialog-title">移除成员</div>
          <button class="group-dialog-close" type="button" @click="cancelRemove">&times;</button>
        </div>
        <div style="padding:0 18px 16px;">
          <div class="group-dialog-note">确定将「{{ removeTarget ? removeTarget.name : '' }}」从群聊中移除吗？移除后该成员将无法查看群聊消息。</div>
          <div v-if="removeError" class="group-dialog-note" style="color:#dc2626;background:rgba(239,68,68,.06);border-color:rgba(239,68,68,.12);">{{ removeError }}</div>
        </div>
        <div class="group-dialog-footer" style="padding:0 18px 16px;display:flex;justify-content:flex-end;gap:10px;">
          <button class="group-dialog-btn" type="button" @click="cancelRemove">取消</button>
          <button class="group-dialog-btn danger" type="button" @click="confirmRemove" :disabled="removeLoading">{{ removeLoading ? '移除中...' : '确认移除' }}</button>
        </div>
      </div>
    </div>
    <!-- Forward Modal(对齐原型 forwardDialogOverlay,4 tab + 多话题/任务展开) -->
    <div v-if="forwardModal.open" class="forward-dialog-overlay open">
      <div class="forward-dialog-scrim" @click="closeForward"></div>
      <div class="forward-dialog">
        <div class="forward-dialog-left">
          <div class="forward-dialog-search-wrap">
            <input class="forward-dialog-search" type="text" v-model="forwardSearch" placeholder="搜索" />
          </div>
          <div class="forward-dialog-list">
            <div class="forward-dialog-tabs">
              <div class="forward-dialog-tabs-inner">
                <button v-for="t in forwardTabDefs" :key="t.key" type="button"
                  class="forward-dialog-tab" :class="{ 'is-active': forwardActiveTabResolved === t.key }"
                  @click="forwardActiveTab = t.key">{{ t.label }}</button>
              </div>
            </div>
            <template v-if="forwardFilteredList.length">
              <template v-for="item in forwardFilteredList">
                <div :key="'fdi-'+item.key" class="forward-dialog-item" :class="{ 'is-selected': item.isSelected }" @click="onForwardItemClick(item)">
                  <div class="forward-dialog-checkbox"></div>
                  <div class="forward-dialog-item-avatar" :style="item.avatarStyle">{{ item.avatar ? '' : (item.name||'?').slice(0,1) }}</div>
                  <div class="forward-dialog-item-copy">
                    <div class="forward-dialog-item-title">
                      <span style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap">{{ item.name }}</span>
                      <span v-if="item.hasMulti" class="forward-dialog-item-badge" :class="{ group: item.type === 'group' }">{{ item.topics.length }} 个{{ item.topicWord }}</span>
                    </div>
                    <div class="forward-dialog-item-sub">{{ item.sub }}</div>
                  </div>
                  <button v-if="item.hasMulti" type="button" class="forward-dialog-topic-toggle" :title="'选择' + item.topicWord" @click.stop="toggleForwardExpand(item.key)">
                    <svg viewBox="0 0 24 24" fill="none" :style="{ width: '15px', height: '15px', transform: 'rotate(' + (item.expanded ? 180 : 0) + 'deg)', transition: 'transform .15s' }"><path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                  </button>
                </div>
                <template v-if="item.topicsRendered">
                  <div v-for="tp in item.topicsRendered" :key="'fdi-sub-'+item.key+'-'+tp.key" class="forward-dialog-item forward-dialog-subitem" :class="{ 'is-selected': tp.isSelected }" @click="onForwardSubItemClick(item.key, tp.key)">
                    <div class="forward-dialog-checkbox"></div>
                    <div class="forward-dialog-item-copy"><div class="forward-dialog-item-title">{{ tp.name }}</div></div>
                  </div>
                </template>
              </template>
            </template>
            <div v-else class="forward-dialog-empty">{{ forwardSearch ? '没有匹配的对话' : '该分类暂无可转发的对话' }}</div>
          </div>
        </div>
        <div class="forward-dialog-right">
          <div class="forward-dialog-right-title">分别发送给</div>
          <div v-if="forwardSelectedItems.length" class="forward-selected-list">
            <div v-for="item in forwardSelectedItems" :key="'fs-'+item.rawKey" class="forward-selected-item">
              <div class="forward-selected-item-avatar" :style="item.avatarStyle">{{ item.avatarText }}</div>
              <div class="forward-selected-item-name">{{ item.name }}</div>
              <button type="button" class="forward-selected-remove" @click="forwardSelected = forwardSelected.filter(k => k !== item.rawKey)" aria-label="移除"><svg viewBox="0 0 24 24" fill="none" width="10" height="10" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg></button>
            </div>
          </div>
          <div v-else class="forward-selected-empty">尚未选择对话</div>
          <div class="forward-preview">
            <span class="forward-preview-label">来自 {{ forwardModal.senderName || '对话' }}</span>
            <span>{{ forwardPreviewText }}</span>
          </div>
          <div class="forward-note-wrap">
            <textarea class="forward-note-input" v-model="forwardComment" placeholder="给朋友留言..." rows="2"></textarea>
          </div>
          <div class="forward-dialog-actions">
            <button class="forward-dialog-btn" type="button" @click="closeForward">取消</button>
            <button class="forward-dialog-btn primary" type="button" :disabled="!forwardSelected.length || forwardSending" @click="doForward">{{ forwardSending ? '发送中…' : (forwardSelected.length ? '分别发送(' + forwardSelected.length + ')' : '分别发送') }}</button>
          </div>
        </div>
      </div>
    </div>
    <!-- 解散群聊确认弹窗（teleport 到 body） -->
    <div v-show="dismissConfirm.open" class="ss-confirm-overlay" ref="dismissOverlay" @click.self="cancelDismiss">
      <div class="ss-confirm-dialog">
        <div class="ss-confirm-title">确认解散「{{ currentSessionName }}」？</div>
        <div class="ss-confirm-desc">解散后所有成员将无法再访问该群聊，操作不可恢复。</div>
        <div class="ss-confirm-actions">
          <button class="ss-confirm-btn" type="button" @click="cancelDismiss" :disabled="dismissConfirm.loading">取消</button>
          <button class="ss-confirm-btn danger" type="button" @click="confirmDismiss" :disabled="dismissConfirm.loading">{{ dismissConfirm.loading ? '处理中…' : '确认解散' }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { api } from '../utils/api'
import { solidFromColor } from '../utils/avatarColor'

// 按类别成块排列（笑脸/反应/手势/爱心/庆祝符号/食物饮品/动物/植物/交通/体育/音乐/办公/时间/服饰），下方 .emoji-menu 滚动
// 元组 [字符, 中文名]：从中派生 EMOJI_LIST（保留顺序）和 EMOJI_NAMES（hover title 用），单一来源避免漂移
const EMOJI_DATA = [
  // 笑脸·情绪
  ['😀','大笑'],['😃','微笑'],['😄','开心'],['😁','露牙'],['😆','眯笑'],['😅','苦笑'],['😂','笑哭'],['🤣','爆笑'],['😊','害羞'],['🙂','浅笑'],
  ['🙃','倒脸'],['😉','眨眼'],['😌','舒心'],['😍','花痴'],['🥰','充爱'],['😘','飞吻'],['😋','馋嘴'],['😜','调皮'],['🤪','抓狂'],['😎','酷'],
  ['🥳','庆祝'],['🤩','星眼'],['🤗','拥抱'],['🤔','思考'],['😇','天使'],['🤭','偷笑'],['🤫','嘘'],['😐','平静'],['😶','沉默'],['🙄','翻眼'],
  ['😏','得意'],['😒','不屑'],['😞','失落'],['😔','沮丧'],['😟','担心'],['🙁','不悦'],['😣','难受'],['😖','困扰'],['😫','疲惫'],['😩','厌倦'],
  ['🥺','委屈'],['😢','哭泣'],['😭','大哭'],['😤','哼气'],['😠','生气'],['😡','愤怒'],['🤯','炸裂'],['😳','脸红'],['😱','尖叫'],['😨','害怕'],
  // 反应·特殊
  ['🥵','发烫'],['🥶','冻僵'],['🤤','流口水'],['😴','睡觉'],['😪','困倦'],['🤢','反胃'],['🤮','呕吐'],['😷','口罩'],['🤒','发烧'],['🤕','受伤'],
  ['🤑','财迷'],['🤠','牛仔'],['😈','笑魔'],['👻','幽灵'],['💀','骷髅'],['🤖','机器'],['🎃','南瓜'],['👽','外星'],
  // 手势·肢体
  ['👋','挥手'],['🤚','举手'],['🖐️','张手'],['✋','停手'],['👌','OK'],['👐','双手'],['🖖','瓦肯'],['✌️','胜利'],['🤞','交指'],['🤟','爱你'],
  ['🤘','摇滚'],['🤙','打电话'],['👈','左指'],['👉','右指'],['👆','上指'],['👇','下指'],['☝️','一指'],['👍','赞'],['👎','踩'],['✊','拳头'],
  ['👊','出拳'],['🤛','左拳'],['🤜','右拳'],['👏','鼓掌'],['🙌','欢呼'],['🤲','捧手'],['🤝','握手'],['🙏','合十'],['💪','肌肉'],['💟','心饰'],
  // 爱心
  ['❤️','红心'],['🧡','橙心'],['💛','黄心'],['💚','绿心'],['💙','蓝心'],['💜','紫心'],['🖤','黑心'],['🤍','白心'],['💔','心碎'],['❣️','心叹'],
  ['💕','双心'],['💖','闪心'],['💗','跳心'],['💘','箭心'],['💝','礼心'],
  // 庆祝·符号·天气
  ['🎉','庆祝'],['🎊','彩纸'],['🎁','礼物'],['🎂','蛋糕'],['🎈','气球'],['🎀','蝴蝶结'],['🌹','玫瑰'],['💐','花束'],['⭐','星星'],['🌟','闪星'],
  ['✨','闪光'],['⚡','闪电'],['🔥','火'],['💥','爆炸'],['💫','晕眩'],['🌈','彩虹'],['☀️','太阳'],['🌙','月亮'],['❄️','雪花'],['💯','满分'],
  ['✅','对勾'],['❌','错号'],['❓','问号'],['❗','感叹'],['⚠️','警告'],['💡','灯泡'],['🔔','铃铛'],['⏰','闹钟'],['👀','看着'],['🎯','靶心'],
  // 食物·水果零食
  ['🍎','苹果'],['🍊','橙子'],['🍌','香蕉'],['🍉','西瓜'],['🍇','葡萄'],['🍓','草莓'],['🍑','桃子'],['🍒','樱桃'],['🍰','蛋糕'],['🍪','饼干'],
  ['🍫','巧克力'],['🍬','糖果'],['🍩','甜甜圈'],['🍕','披萨'],['🍔','汉堡'],['🍟','薯条'],['🍜','拉面'],['🍣','寿司'],['🍙','饭团'],['🌮','塔可'],
  // 饮品
  ['☕','咖啡'],['🍵','茶'],['🥛','牛奶'],['🥤','汽水'],['🍺','啤酒'],['🍻','干杯'],['🍷','红酒'],['🍸','鸡尾酒'],['🥂','香槟'],['🍹','果汁'],
  // 食物·主食 / 早餐 / 烘焙
  ['🍞','面包'],['🥐','牛角'],['🥖','法棍'],['🥨','椒盐'],['🧀','奶酪'],['🥚','鸡蛋'],['🍳','煎蛋'],['🥞','松饼'],['🥓','培根'],['🥩','肉排'],
  ['🍗','鸡腿'],['🍖','烤肉'],['🌭','热狗'],['🍿','爆米花'],['🥗','沙拉'],['🥘','焖锅'],['🍲','炖锅'],['🥟','饺子'],['🥧','派'],['🍯','蜂蜜'],
  // 蔬果·零食
  ['🥭','芒果'],['🥥','椰子'],['🥝','猕猴桃'],['🍅','番茄'],['🍆','茄子'],['🥑','牛油果'],['🥦','西兰花'],['🥒','黄瓜'],['🌶️','辣椒'],['🌽','玉米'],
  ['🥕','胡萝卜'],['🥔','土豆'],['🍠','红薯'],['🥜','花生'],['🌰','栗子'],['🍡','团子'],['🍧','刨冰'],['🍨','雪糕'],['🍦','冰激凌'],['🥮','月饼'],
  // 动物·哺乳
  ['🐶','狗狗'],['🐱','猫咪'],['🐭','老鼠'],['🐹','仓鼠'],['🐰','兔子'],['🦊','狐狸'],['🐻','熊'],['🐼','熊猫'],['🐨','考拉'],['🐯','老虎'],
  ['🦁','狮子'],['🐮','奶牛'],['🐷','小猪'],['🐸','青蛙'],['🐵','猴子'],['🙈','不看'],['🙉','不听'],['🙊','不说'],['🦄','独角兽'],['🐝','蜜蜂'],
  // 动物·猫脸 / 鸟 / 虫鱼海
  ['😺','笑猫'],['😸','露牙猫'],['😹','笑哭猫'],['😻','爱心猫'],['😼','坏笑猫'],['😽','飞吻猫'],['🙀','惊猫'],['😿','哭猫'],
  ['🐔','公鸡'],['🐧','企鹅'],['🐦','小鸟'],['🐤','小鸡'],['🐣','雏鸡'],['🦆','鸭子'],['🦅','老鹰'],['🦉','猫头鹰'],['🦇','蝙蝠'],['🐺','狼'],
  ['🦋','蝴蝶'],['🐌','蜗牛'],['🐞','瓢虫'],['🐢','乌龟'],['🐍','蛇'],['🐙','章鱼'],['🦀','螃蟹'],['🐠','热带鱼'],['🐬','海豚'],['🐳','鲸鱼'],
  // 植物·自然
  ['🌵','仙人掌'],['🌲','松树'],['🌳','大树'],['🌴','棕榈'],['🌱','嫩芽'],['🌿','香草'],['☘️','三叶'],['🍀','四叶'],['🍃','飘叶'],['🍂','落叶'],
  ['🍁','枫叶'],['🍄','蘑菇'],['🌷','郁金香'],['🌸','樱花'],['🌻','向日葵'],
  // 交通·旅行 / 地标
  ['🚗','汽车'],['🚕','出租'],['🚙','越野'],['🚌','公交'],['🚑','救护'],['🚒','消防'],['🏍️','摩托'],['🚲','单车'],['✈️','飞机'],['🚀','火箭'],
  ['⛵','帆船'],['🚂','蒸汽'],['🚄','高铁'],['🚁','直升机'],['🛸','飞碟'],['🏝️','海岛'],['🏖️','沙滩'],['🌋','火山'],['⛰️','山'],['🗽','自由'],
  // 体育·游戏
  ['🏆','奖杯'],['🥇','金牌'],['🥈','银牌'],['🥉','铜牌'],['⚽','足球'],['🏀','篮球'],['🏈','橄榄'],['⚾','棒球'],['🎾','网球'],['🏐','排球'],
  ['⛳','高尔夫'],['🎳','保龄'],['🎮','游戏'],['🎲','骰子'],['🧩','拼图'],
  // 音乐·乐器
  ['🎼','乐谱'],['🎵','单音'],['🎶','多音'],['🎤','麦克'],['🎧','耳机'],['🎷','萨克'],['🎸','吉他'],['🎹','钢琴'],['🎺','小号'],['🥁','鼓'],
  // 办公·科技 / 通讯
  ['💻','笔电'],['⌨️','键盘'],['🖱️','鼠标'],['🖥️','显示器'],['📷','相机'],['📹','摄像'],['🎥','摄影'],['📞','电话'],['📱','手机'],['📺','电视'],
  ['💾','软盘'],['💿','光盘'],['🔋','电池'],['🔌','插头'],['📡','天线'],['🔧','扳手'],['🔨','锤子'],['⚙️','齿轮'],['🔑','钥匙'],
  ['✉️','信封'],['📧','邮件'],['📦','包裹'],['📌','图钉'],['📝','备忘'],
  // 时间
  ['🕐','1点'],['🕑','2点'],['🕒','3点'],['🕓','4点'],['🕔','5点'],['🕕','6点'],['🕖','7点'],['🕗','8点'],['🕘','9点'],['🕙','10点'],
  ['🕚','11点'],['🕛','12点'],['⌛','沙漏'],['⏳','流沙'],
  // 服饰·配饰
  ['👑','王冠'],['🎩','礼帽'],['🎓','学位帽'],['🧢','棒球帽'],['👓','眼镜'],['👕','T恤'],['👖','牛仔'],['👗','裙子'],['👠','高跟'],['👜','包包']
]
const EMOJI_LIST = EMOJI_DATA.map(([c]) => c)
const EMOJI_NAMES = Object.fromEntries(EMOJI_DATA)

export default {
  name: 'TelegramMenus',
  data() {
    return {
      emojiList: EMOJI_LIST,
      mentionTop: null,
      replyMenuTopCorrected: null,  // post-render 校正后 top,null 时回退到 replyMenu.y
      memberManagerOpen: false,
      memberManagerQuery: '',
      memberManagerList: [],
      removeConfirmOpen: false,
      removeTarget: null,
      removeLoading: false,
      removeError: '',
      forwardSearch: '',
      forwardSelected: [],   // 元素可为 sessionKey 或 sessionKey::topicKey
      forwardComment: '',
      forwardSending: false,
      forwardActiveTab: 'all',   // all / agent / group / coworker
      forwardExpanded: {},   // { [sessionKey]: bool } 多话题/任务展开态
      dismissConfirm: { open: false, loading: false }
    }
  },
  computed: {
    ...mapState(['telegramGroupMenu', 'telegramReplyMenu', 'telegramEmojiMenu', 'telegramMentionMenu', 'composerInputValues', 'currentTopicsPageKey', 'currentSessionKey', 'mentionActiveIndex']),
    activeIndex() { return this.mentionActiveIndex },
    groupMenu() { return this.telegramGroupMenu },
    replyMenu() { return this.telegramReplyMenu },
    // 实际高度校正后的 top:渲染前先用 store 给的值,$nextTick 测真实 offsetHeight 再调整
    replyMenuTop() { return this.replyMenuTopCorrected != null ? this.replyMenuTopCorrected : this.replyMenu.y },
    isCurrentMessagePinned() {
      const messageId = this.replyMenu && this.replyMenu.messageId
      if (!messageId) return false
      const item = this.$store.state.sessionItems.find(s => s.key === this.$store.state.currentSessionKey)
      const conversationId = item && item.conversationId
      if (!conversationId) return false
      const topicId = this.$store.state.currentTopicKey
      const key = `${conversationId}::${topicId || 'default'}`
      const list = this.$store.state.conversationPinnedMessages[key] || []
      return list.some(p => p.messageId === messageId)
    },
    emojiMenu() { return this.telegramEmojiMenu },
    mentionMenu() { return this.telegramMentionMenu },
    hasTopics() { return !!this.currentTopicsPageKey },
    isCurrentAdmin() {
      const item = this.$store.state.sessionItems.find(s => s.key === this.$store.state.currentSessionKey)
      return !!(item && item.isAdmin)
    },
    currentSessionHasMultipleTopics() {
      const item = this.$store.state.sessionItems.find(s => s.key === this.$store.state.currentSessionKey)
      return !!(item && item.hasTopics)
    },
    isCurrentGroup() {
      const item = this.$store.state.sessionItems.find(s => s.key === this.$store.state.currentSessionKey)
      return !!(item && item.type === 'group')
    },
    currentSessionName() {
      const item = this.$store.state.sessionItems.find(s => s.key === this.$store.state.currentSessionKey)
      return item ? item.name : ''
    },
    memberManagerUserCount() {
      return this.memberManagerList.filter(m => m.type !== 'agent').length
    },
    memberManagerAgentCount() {
      return this.memberManagerList.filter(m => m.type === 'agent').length
    },
    filteredManagerMembers() {
      const q = (this.memberManagerQuery || '').trim().toLowerCase()
      const list = this.memberManagerList
      return q ? list.filter(m => (m.name || '').toLowerCase().includes(q)) : list
    },
    isCurrentTopicDefault() {
      if (!this.currentTopicsPageKey) return false
      const page = this.$store.state.sessionTopicPages[this.currentTopicsPageKey]
      if (!page) return false
      const topicId = this.$store.state.currentTopicKey
      const topic = page.topics.find(t => t.key === topicId)
      return !!(topic && topic.isDefault)
    },
    mentionStyle() {
      const m = this.mentionMenu
      if (!m || !m.open) return {}
      return {
        left: m.x + 'px',
        top: (this.mentionTop != null ? this.mentionTop : m.y) + 'px'
      }
    },
    forwardModal() { return this.$store.state.forwardModal },
    forwardTabDefs() {
      return [
        { key: 'all', label: '全部' },
        { key: 'agent', label: 'Agent' },
        { key: 'group', label: '群' },
        { key: 'coworker', label: '同事' }
      ]
    },
    forwardAllSessions() {
      // 排序: Agent → 同事 → 群组(spec section 6.1);排除已退出和当前所在会话
      const cur = this.$store.state.currentSessionKey
      const order = { agent: 0, coworker: 1, group: 2 }
      return this.$store.state.sessionItems
        .filter(s => !s.exited && s.key !== cur)
        .slice()
        .sort((a, b) => (order[a.type] || 9) - (order[b.type] || 9))
    },
    forwardTabCounts() {
      const c = { all: 0, agent: 0, group: 0, coworker: 0 }
      this.forwardAllSessions.forEach(s => { c.all++; if (c[s.type] != null) c[s.type]++ })
      return c
    },
    // 当前 tab 空集时,fallback 到 all(用户点的 tab 本身就没数据时无意义,但已搜索导致空不算)
    forwardActiveTabResolved() {
      const t = this.forwardActiveTab
      if (t === 'all') return 'all'
      return this.forwardTabCounts[t] ? t : 'all'
    },
    // 包装后的 list,每项都预算好 topics/sub/isSelected/avatarStyle/multi 标记
    // template 里 v-for 直接读字段,不再调 method;避免 forwardSelected 一变 N 个方法重算
    forwardFilteredList() {
      const tab = this.forwardActiveTabResolved
      let list = tab === 'all' ? this.forwardAllSessions.slice() : this.forwardAllSessions.filter(s => s.type === tab)
      const q = this.forwardSearch.trim().toLowerCase()
      if (q) list = list.filter(s => (s.name || '').toLowerCase().includes(q))
      const pages = this.$store.state.sessionTopicPages
      const selSet = new Set(this.forwardSelected)
      return list.map(s => {
        const page = s.topicKey ? pages[s.topicKey] : null
        const topics = (page && Array.isArray(page.topics)) ? page.topics : []
        const hasMulti = topics.length > 1
        const isSelected = hasMulti
          ? topics.some(tp => selSet.has(s.key + '::' + tp.key))
          : selSet.has(s.key)
        const sub = s.type === 'agent' ? 'Agent 对话'
          : s.type === 'group' ? ('群组 · ' + (s.memberCount || 0) + '人')
          : '同事'
        let avatarStyle
        if (s.avatar) {
          avatarStyle = { background: '#eee center/cover no-repeat url(' + s.avatar + ')' }
        } else {
          const bg = s.type === 'agent' ? 'linear-gradient(135deg,#7B61FF,#5B8DEF)'
            : s.type === 'group' ? 'linear-gradient(135deg,#F0A83D,#E8833A)'
            : 'linear-gradient(135deg,#35B58A,#3FC89E)'
          avatarStyle = { background: bg }
        }
        const topicWord = s.type === 'group' ? '话题' : '任务'
        return {
          key: s.key,
          name: s.name,
          type: s.type,
          avatar: s.avatar,
          memberCount: s.memberCount,
          topics, hasMulti, isSelected, sub, avatarStyle, topicWord,
          expanded: !!this.forwardExpanded[s.key],
          // 子项的 selected 标记
          topicsRendered: hasMulti && this.forwardExpanded[s.key]
            ? topics.map(tp => ({ key: tp.key, name: tp.name, isSelected: selSet.has(s.key + '::' + tp.key) }))
            : null
        }
      })
    },
    // 右侧选中列表 — 一次性映射,免去 v-for 中重复 sessionItems.find
    forwardSelectedItems() {
      const byKey = {}
      this.$store.state.sessionItems.forEach(i => { byKey[i.key] = i })
      const pages = this.$store.state.sessionTopicPages
      return this.forwardSelected.map(rawKey => {
        const idx = rawKey.indexOf('::')
        const sessionKey = idx < 0 ? rawKey : rawKey.slice(0, idx)
        const topicKey = idx < 0 ? null : rawKey.slice(idx + 2)
        const s = byKey[sessionKey]
        if (!s) return { rawKey, name: rawKey, avatarStyle: { background: '#ccc' }, avatarText: '?' }
        let name = s.name
        if (topicKey) {
          const page = pages[s.topicKey]
          const t = page && page.topics && page.topics.find(tp => tp.key === topicKey)
          name = s.name + ' · ' + (t ? t.name : '')
        }
        let avatarStyle
        if (s.avatar) {
          avatarStyle = { background: '#eee center/cover no-repeat url(' + s.avatar + ')' }
        } else {
          const bg = s.type === 'agent' ? 'linear-gradient(135deg,#7B61FF,#5B8DEF)'
            : s.type === 'group' ? 'linear-gradient(135deg,#F0A83D,#E8833A)'
            : 'linear-gradient(135deg,#35B58A,#3FC89E)'
          avatarStyle = { background: bg }
        }
        const avatarText = s.avatar ? '' : (s.name || '?').slice(0, 1)
        return { rawKey, name, avatarStyle, avatarText }
      })
    },
    forwardPreviewText() {
      const m = this.forwardModal
      if (!m) return ''
      if (m.kind === 'image') return '[图片] ' + (m.fileName || '')
      if (m.kind === 'file' || m.kind === 'document') return '[文件] ' + (m.fileName || '')
      if (m.kind === 'video') return '[视频]'
      if (m.kind === 'audio') return '[语音]'
      return m.text || ''
    }
  },
  watch: {
    mentionActiveIndex(idx) {
      this.$nextTick(() => {
        const ref = this.$refs['mentionItem' + idx]
        const el = Array.isArray(ref) ? ref[0] : ref
        if (el && el.scrollIntoView) el.scrollIntoView({ block: 'nearest' })
      })
    },
    'mentionMenu.open'(open) {
      this.mentionTop = null
      if (open) this.$nextTick(() => this.repositionMention())
    },
    'replyMenu.open'(open) {
      this.replyMenuTopCorrected = null
      if (open) this.$nextTick(() => this.repositionReplyMenu())
    },
    'replyMenu.y'() {
      // 同一气泡反复右键时,store y 变化要触发重新校正
      if (this.replyMenu.open) this.$nextTick(() => this.repositionReplyMenu())
    },
    'mentionMenu.members'() {
      if (this.mentionMenu.open) {
        this.mentionTop = null
        this.$nextTick(() => this.repositionMention())
      }
    }
  },
  methods: {
    ...mapMutations(['SET_TELEGRAM_GROUP_MENU', 'SET_TELEGRAM_REPLY_MENU', 'SET_TELEGRAM_EMOJI_MENU', 'SET_TELEGRAM_MENTION_MENU', 'CLOSE_TELEGRAM_MENUS', 'SET_GROUP_DIALOG', 'SET_TELEGRAM_PENDING_REPLY', 'SET_COMPOSER_INPUT', 'ADD_PENDING_MENTION']),
    emojiName(e) { return EMOJI_NAMES[e] || '' },
    groupAction(mode) {
      this.CLOSE_TELEGRAM_MENUS()
      this.SET_GROUP_DIALOG({ open: true, mode, sessionKey: this.currentSessionKey })
    },
    showDismiss() {
      this.CLOSE_TELEGRAM_MENUS()
      this.dismissConfirm = { open: true, loading: false }
    },
    cancelDismiss() {
      this.dismissConfirm = { open: false, loading: false }
    },
    async confirmDismiss() {
      const item = this.$store.state.sessionItems.find(s => s.key === this.$store.state.currentSessionKey)
      const convId = item ? item.conversationId : null
      if (!convId) { this.dismissConfirm = { open: false, loading: false }; return }
      this.dismissConfirm.loading = true
      try {
        const { api } = require('../utils/api')
        await api.dismissConversation(convId)
        await this.$store.dispatch('fetchConversations', { force: true })
        // 解散后立即刷新账号级总未读，否则解散群的未读会一直挂在 totalUnread 上，等轮询才消失
        this.$store.dispatch('fetchUnreadCount')
        this.dismissConfirm = { open: false, loading: false }
      } catch (e) {
        console.warn('[TelegramMenus] dismissConversation failed:', e && e.message)
        this.dismissConfirm.loading = false
      }
    },
    async openMemberManager() {
      this.CLOSE_TELEGRAM_MENUS()
      this.memberManagerQuery = ''
      this.memberManagerList = []
      this.memberManagerOpen = true
      const convId = this.$store.getters.currentConversationId
      if (!convId) return
      const currentUserId = this.$store.state.currentUserId
      try {
        const data = await api.getGroupMembers(convId)
        const members = Array.isArray(data) ? data : (data && data.members ? data.members : [])
        this.memberManagerList = members.map((m) => ({
          id: m.userId,
          agentId: m.agentId || null,
          name: m.name || '成员',
          type: m.type === 'agent' ? 'agent' : 'account',
          avatarUrl: m.avatarUrl || null,
          avatarText: (m.name || '?').slice(0, 1),
          avatarBackground: solidFromColor(m.avatarColorRgb),
          role: m.role || '',
          isSelf: m.userId === currentUserId && m.type !== 'agent',
          isOwner: m.role === 'admin' || m.role === 'owner',
          ownerName: m.ownerName || m.owner_name || '',
          ownerId: m.ownerId || m.owner_id || ''
        }))
      } catch (e) {
        console.warn('[TelegramMenus] getGroupMembers failed:', e.message)
      }
    },
    removeMember(member) {
      this.removeTarget = member
      this.removeConfirmOpen = true
    },
    async confirmRemove() {
      const member = this.removeTarget
      if (!member) return
      this.removeLoading = true
      const convId = this.$store.getters.currentConversationId
      if (!convId) return
      try {
        const { api } = require('../utils/api')
        if (member.type === 'agent') {
          await api.kickAgentFromConversation(convId, member.agentId)
        } else {
          await api.kickMemberFromConversation(convId, member.id)
        }
        this.memberManagerList = this.memberManagerList.filter(m => {
          if (member.type === 'agent') return m.agentId !== member.agentId
          return m.id !== member.id || m.type === 'agent'
        })
        this.$store.dispatch('fetchMentionableMembers', convId)
        this.removeConfirmOpen = false
        this.removeTarget = null
      } catch (e) {
        this.removeError = e.message || '移除失败'
      } finally {
        this.removeLoading = false
      }
    },
    cancelRemove() {
      this.removeConfirmOpen = false
      this.removeTarget = null
      this.removeError = ''
    },
    async enterChat(m) {
      this.memberManagerOpen = false
      try {
        await this.$store.dispatch('createDirectSession', { participantId: m.id })
      } catch (e) {
        console.warn('[TelegramMenus] enterChat failed:', e.message)
      }
    },
    doReply() {
      this.SET_TELEGRAM_PENDING_REPLY({
        name: this.replyMenu.name,
        text: this.replyMenu.text,
        messageId: this.replyMenu.messageId,
        kind: this.replyMenu.kind || 'text',
        files: this.replyMenu.files || null,
        imageUrl: this.replyMenu.imageUrl || '',
        fileName: this.replyMenu.fileName || ''
      })
      this.CLOSE_TELEGRAM_MENUS()
      this.$nextTick(() => {
        const ta = document.querySelector('.telegram-editor textarea')
        if (ta) ta.focus()
      })
    },
    copyMessage() {
      const text = this.replyMenu.text || ''
      if (navigator.clipboard) {
        navigator.clipboard.writeText(text).catch(() => {})
      } else {
        const ta = document.createElement('textarea')
        ta.value = text
        ta.style.cssText = 'position:fixed;opacity:0'
        document.body.appendChild(ta)
        ta.select()
        try { document.execCommand('copy') } catch {}
        document.body.removeChild(ta)
      }
      this.CLOSE_TELEGRAM_MENUS()
    },
    async copyImage() {
      const url = this.replyMenu.clickedImageUrl
      this.CLOSE_TELEGRAM_MENUS()
      if (!url) return
      let blob = null
      try {
        const resp = await fetch(url, { mode: 'cors', credentials: 'omit' })
        if (!resp.ok) throw new Error('HTTP ' + resp.status)
        blob = await resp.blob()
      } catch (e) {
        console.warn('[copyImage] fetch failed:', e)
      }
      // 路径 A：async clipboard（仅 HTTPS / 安全上下文可用）
      if (blob && window.isSecureContext && window.ClipboardItem && navigator.clipboard && navigator.clipboard.write) {
        try {
          const pngBlob = blob.type === 'image/png' ? blob : await this._imageBlobToPng(blob)
          await navigator.clipboard.write([new ClipboardItem({ 'image/png': pngBlob })])
          console.log('[copyImage] async clipboard OK')
          return
        } catch (e) {
          console.warn('[copyImage] async clipboard write failed:', e)
        }
      }
      // 路径 B：contenteditable + 已加载渲染的 <img> + selectNode + execCommand
      //         让 Chromium 把位图写进系统剪贴板（CF_DIB / CF_BITMAP），微信/QQ 才认
      if (blob) {
        try {
          const ok = await this._copyImgAsBitmap(blob)
          if (ok) { console.log('[copyImage] bitmap-copy OK'); return }
        } catch (e) {
          console.warn('[copyImage] bitmap-copy failed:', e)
        }
        // 路径 C：copy 事件拦截写 HTML（web 应用能收，原生 IM 不行）
        try {
          const dataUrl = await this._blobToDataUrl(blob)
          const ok = this._copyHtmlViaCopyEvent(`<img src="${dataUrl}">`, '[图片]')
          if (ok) { console.log('[copyImage] html-copy OK (web app only)'); return }
        } catch (e) {
          console.warn('[copyImage] html-copy failed:', e)
        }
      }
      // 路径 D：兜底复制 URL 文本
      const okText = this._copyHtmlViaCopyEvent(null, url)
      if (!okText) console.warn('[copyImage] all paths failed')
    },
    async downloadFile() {
      const url = this.replyMenu.clickedFileUrl
      const name = this.replyMenu.clickedFileName || 'download'
      this.CLOSE_TELEGRAM_MENUS()
      if (!url) return
      try {
        const res = await fetch(url)
        if (!res.ok) throw new Error('HTTP ' + res.status)
        const blob = await res.blob()
        const blobUrl = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = blobUrl
        a.download = name
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        setTimeout(() => URL.revokeObjectURL(blobUrl), 10000)
      } catch (e) {
        console.warn('[downloadFile] fetch failed, fallback to open:', e)
        window.open(url, '_blank')
      }
    },
    _copyImgAsBitmap(blob) {
      return new Promise((resolve) => {
        const blobUrl = URL.createObjectURL(blob)
        const div = document.createElement('div')
        div.contentEditable = 'true'
        // 关键：要 viewport 内且实际渲染过；opacity:0/display:none/离屏都会让 Chromium 跳过位图写入
        div.style.cssText = 'position:fixed;left:0;top:0;width:1px;height:1px;overflow:hidden;opacity:0.01;pointer-events:none;z-index:-9999;background:#fff'
        const img = document.createElement('img')
        img.style.cssText = 'display:block;'
        let settled = false
        const finish = (ok) => {
          if (settled) return
          settled = true
          URL.revokeObjectURL(blobUrl)
          try { document.body.removeChild(div) } catch (_) {}
          resolve(ok)
        }
        img.onload = () => {
          // 等两帧 RAF 确保完成 paint
          requestAnimationFrame(() => requestAnimationFrame(() => {
            try {
              div.focus()
              const sel = window.getSelection()
              const range = document.createRange()
              range.selectNode(img)
              sel.removeAllRanges()
              sel.addRange(range)
              let ok = false
              try { ok = document.execCommand('copy') } catch (e) { console.warn('[bitmap-copy] execCommand threw:', e) }
              sel.removeAllRanges()
              finish(ok)
            } catch (e) {
              console.warn('[bitmap-copy] select/copy threw:', e)
              finish(false)
            }
          }))
        }
        img.onerror = (e) => { console.warn('[bitmap-copy] img load failed', e); finish(false) }
        img.src = blobUrl
        div.appendChild(img)
        document.body.appendChild(div)
        setTimeout(() => finish(false), 8000)
      })
    },
    _imageBlobToPng(blob) {
      return new Promise((resolve, reject) => {
        const img = new Image()
        const objUrl = URL.createObjectURL(blob)
        img.onload = () => {
          const c = document.createElement('canvas')
          c.width = img.naturalWidth
          c.height = img.naturalHeight
          c.getContext('2d').drawImage(img, 0, 0)
          c.toBlob(b => { URL.revokeObjectURL(objUrl); b ? resolve(b) : reject(new Error('toBlob failed')) }, 'image/png')
        }
        img.onerror = () => { URL.revokeObjectURL(objUrl); reject(new Error('image load failed')) }
        img.src = objUrl
      })
    },
    _blobToDataUrl(blob) {
      return new Promise((resolve, reject) => {
        const r = new FileReader()
        r.onload = () => resolve(r.result)
        r.onerror = () => reject(r.error || new Error('FileReader failed'))
        r.readAsDataURL(blob)
      })
    },
    // 通用：拦截 copy 事件强写 clipboardData。html=null 则只写 text。
    _copyHtmlViaCopyEvent(html, plainText) {
      const ta = document.createElement('textarea')
      ta.value = plainText || ' '
      ta.setAttribute('readonly', '')
      ta.style.cssText = 'position:fixed;top:0;left:0;width:2em;height:2em;padding:0;border:0;opacity:0;'
      document.body.appendChild(ta)
      const handler = (e) => {
        try {
          e.preventDefault()
          if (html) e.clipboardData.setData('text/html', html)
          e.clipboardData.setData('text/plain', plainText || '')
        } catch (err) { console.warn('[clipboardData.setData] failed:', err) }
      }
      document.addEventListener('copy', handler, { once: true, capture: true })
      ta.focus()
      ta.select()
      let ok = false
      try { ok = document.execCommand('copy') } catch (e) { console.warn('[execCommand copy] threw:', e) }
      document.removeEventListener('copy', handler, { capture: true })
      document.body.removeChild(ta)
      return ok
    },
    enterMultiSelect() {
      const rm = this.replyMenu
      const msg = { id: rm.messageId, seq: rm.seq || 0, name: rm.name || '', text: rm.text || '', kind: rm.kind || 'text', fileName: rm.fileName || '', imageUrl: rm.imageUrl || '', fileUrl: rm.fileUrl || '', mimeType: rm.mimeType || '', fileSizeStr: rm.fileSizeStr || '' }
      this.$store.commit('CLOSE_TELEGRAM_MENUS')
      this.$store.commit('ENTER_MULTI_SELECT', msg)
    },
    togglePin() {
      const rm = this.replyMenu
      const messageId = rm && rm.messageId
      const item = this.$store.state.sessionItems.find(s => s.key === this.$store.state.currentSessionKey)
      const conversationId = item && item.conversationId
      if (!messageId || !conversationId) {
        this.$store.commit('CLOSE_TELEGRAM_MENUS')
        return
      }
      const topicId = this.$store.state.currentTopicKey || undefined
      const wasPinned = this.isCurrentMessagePinned
      this.$store.commit('CLOSE_TELEGRAM_MENUS')
      if (wasPinned) {
        this.$store.dispatch('unpinMessage', { conversationId, topicId, messageId })
      } else {
        const message = {
          id: messageId,
          sender: { id: rm.senderId || '', name: rm.name || '' },
          body: { text: rm.text || '' },
          createdAt: rm.createdAt || new Date().toISOString()
        }
        this.$store.dispatch('pinMessage', { conversationId, topicId, message })
      }
    },
    openForward() {
      const rm = this.replyMenu
      this.$store.commit('CLOSE_TELEGRAM_MENUS')
      this.$store.commit('SET_FORWARD_MODAL', {
        open: true, senderName: rm.name || '未知', text: rm.text || '',
        kind: rm.kind || 'text', imageUrl: rm.imageUrl || '',
        fileUrl: rm.fileUrl || '', fileName: rm.fileName || '',
        mimeType: rm.mimeType || '', files: rm.files || null,
        imageWidth: rm.imageWidth || 0, imageHeight: rm.imageHeight || 0,
        fileSize: rm.fileSize || 0, fileSizeStr: rm.fileSizeStr || ''
      })
      this.forwardSearch = ''
      this.forwardSelected = []
      this.forwardComment = ''
      this.forwardActiveTab = 'all'
      this.forwardExpanded = {}
    },
    closeForward() {
      this.$store.commit('CLOSE_FORWARD_MODAL')
      this.forwardSearch = ''
      this.forwardSelected = []
      this.forwardComment = ''
      this.forwardSending = false
      this.forwardActiveTab = 'all'
      this.forwardExpanded = {}
    },
    forwardSessionName(key) {
      const s = this.$store.state.sessionItems.find(i => i.key === key)
      return s ? s.name : key
    },
    // ── 转发弹窗(item 都是 forwardFilteredList 出来的 enriched 对象,topics 已预算) ──
    onForwardItemClick(item) {
      const topics = item.topics
      if (topics.length > 1) {
        const anySel = topics.some(tp => this.forwardSelected.includes(item.key + '::' + tp.key))
        if (anySel) {
          this.forwardSelected = this.forwardSelected.filter(k => !topics.some(tp => k === item.key + '::' + tp.key))
          this.$set(this.forwardExpanded, item.key, false)
        } else {
          this.$set(this.forwardExpanded, item.key, true)
          this.forwardSelected = this.forwardSelected.concat([item.key + '::' + topics[0].key])
        }
      } else {
        const idx = this.forwardSelected.indexOf(item.key)
        if (idx >= 0) this.forwardSelected = this.forwardSelected.filter(k => k !== item.key)
        else this.forwardSelected = this.forwardSelected.concat([item.key])
      }
    },
    onForwardSubItemClick(itemKey, topicKey) {
      const k = itemKey + '::' + topicKey
      const idx = this.forwardSelected.indexOf(k)
      if (idx >= 0) this.forwardSelected = this.forwardSelected.filter(x => x !== k)
      else this.forwardSelected = this.forwardSelected.concat([k])
    },
    toggleForwardExpand(itemKey) {
      this.$set(this.forwardExpanded, itemKey, !this.forwardExpanded[itemKey])
    },
    _forwardParseKey(rawKey) {
      const idx = rawKey.indexOf('::')
      if (idx < 0) return { sessionKey: rawKey, topicKey: null }
      return { sessionKey: rawKey.slice(0, idx), topicKey: rawKey.slice(idx + 2) }
    },
    _inferFileType(f) {
      // 优先用原始 file.type;再看 mimeType;最后兜底 file
      if (f && f.type && f.type !== 'multi') return f.type
      const mt = (f && f.mimeType) || ''
      if (mt.startsWith('image/')) return 'image'
      if (mt.startsWith('video/')) return 'video'
      if (mt.startsWith('audio/')) return 'audio'
      return 'file'
    },
    _buildForwardFiles(m) {
      // 多文件:用 m.files 完整数组(保留每个 file 的 type/width/height/mimeType 等)
      if (m.files && m.files.length) {
        return m.files.map(f => {
          const file = {
            url: f.url || '',
            name: f.name || f.fileName || '',
            type: this._inferFileType(f),
            mimeType: f.mimeType || ''
          }
          const size = f.size || f.fileSize
          if (size) file.size = size
          if (f.width) file.width = f.width
          if (f.height) file.height = f.height
          if (f.duration) file.duration = f.duration
          return file
        }).filter(f => f.url)
      }
      // 单文件兜底:从 imageUrl/fileUrl + msg 顶层字段组装
      const url = m.imageUrl || m.fileUrl || ''
      if (!url) return []
      const isImg = m.kind === 'image' || (m.mimeType || '').startsWith('image/')
      const file = {
        url,
        name: m.fileName || '',
        type: isImg ? 'image' : (m.kind && m.kind !== 'multi' ? m.kind : 'file'),
        mimeType: m.mimeType || ''
      }
      if (m.fileSize) file.size = m.fileSize
      if (isImg) {
        if (m.imageWidth) file.width = m.imageWidth
        if (m.imageHeight) file.height = m.imageHeight
      }
      return [file]
    },
    _stripForwardPrefix(text) {
      if (!text) return ''
      let t = text
      let prev = ''
      while (t !== prev) {
        prev = t
        // 只去转发前缀行，保留其余内容（包括留言）
        t = t.replace(/^【转发消息】来自\s+\S+?[：:]\s*/, '')
             .replace(/^【合并转发】\n?/, '')
             .replace(/^转发自\s+\S+?[：:]\s*/, '')
             .replace(/^转发自\s+\S+?\s*\n/, '')  // "转发自 XXX\n" 无冒号、后面还有内容
             .replace(/^转发自\s+\S+?\s*$/, '')    // "转发自 XXX" 无冒号、到末尾
      }
      // 去掉开头的 "留言：" 前缀（上一轮留言变成了正文开头）
      t = t.replace(/^留言：/, '')
      return t.trim()
    },
    async _forwardOneMsg(convId, m, comment, topicId) {
      const from = m.senderName || m.name || '未知'
      const files = this._buildForwardFiles(m)
      const cleanText = this._stripForwardPrefix(m.text)
      if (files.length) {
        let caption = '转发自 ' + from
        if (cleanText) caption += '：' + cleanText
        if (comment) caption += '\n留言：' + comment
        await api.sendMediaMessage(convId, { messageType: 'file', body: { files, caption }, topicId })
      } else {
        let text = '【转发消息】来自 ' + from + '：' + (cleanText || '')
        if (comment) text += '\n留言：' + comment
        await api.sendMessage(convId, { text, topicId })
      }
    },
    async doForward() {
      if (!this.forwardSelected.length || this.forwardSending) return
      this.forwardSending = true
      const fm = this.forwardModal
      const comment = this.forwardComment.trim()
      // 把选中 key 解析成 {session, explicitTopic} — 用户在多话题/任务里点了具体子项就走 explicit
      const targets = this.forwardSelected.map(rawKey => {
        const { sessionKey, topicKey } = this._forwardParseKey(rawKey)
        const s = this.$store.state.sessionItems.find(i => i.key === sessionKey)
        return { session: s, explicitTopic: topicKey }
      }).filter(t => t.session && t.session.conversationId)

      try {
        const _getTopicId = (t) => {
          if (t.explicitTopic) return t.explicitTopic
          const s = t.session
          const page = s.topicKey && this.$store.state.sessionTopicPages[s.topicKey]
          if (page && page.activeKey) return page.activeKey
          if (page && page.topics && page.topics.length) return page.topics[0].key
          return undefined
        }
        if (fm.kind === 'multi-forward-each' && fm._messages) {
          // 逐条转发
          for (const t of targets) {
            const topicId = _getTopicId(t)
            for (const m of fm._messages) {
              try { await this._forwardOneMsg(t.session.conversationId, m, comment, topicId) } catch (e) { /* ignore */ }
            }
          }
        } else if (fm.kind === 'multi-forward-merge' && fm._messages) {
          // 合并转发：编码成一条文本消息，图片 URL 内嵌，渲染端解析
          const lines = fm._messages.map(m => {
            const from = m.senderName || m.name || '未知'
            const imgUrl = m.imageUrl || (m.kind === 'image' ? (m.fileUrl || '') : '')
            const fileUrl = (!imgUrl && m.fileUrl) ? m.fileUrl : ''
            const cleanText = this._stripForwardPrefix(m.text)
            let line = from + '：'
            if (imgUrl) line += '[img:' + imgUrl + ']'
            if (fileUrl) line += '[file:' + (m.fileName || '文件') + ':' + (m.fileSizeStr || '') + ':' + fileUrl + ']'
            if (cleanText) line += cleanText
            return line
          })
          const text = '【合并转发】\n' + lines.join('\n')
          for (const t of targets) {
            const topicId = _getTopicId(t)
            try { await api.sendMessage(t.session.conversationId, { text, topicId }) } catch (e) { /* ignore */ }
          }
        } else {
          // 单条转发
          for (const t of targets) {
            const topicId = _getTopicId(t)
            try { await this._forwardOneMsg(t.session.conversationId, fm, comment, topicId) } catch (e) { /* ignore */ }
          }
        }
      } finally {
        this.forwardSending = false
        this.closeForward()
      }
    },
    insertEmoji(emoji) {
      const { context, selStart, selEnd, val, textareaId } = this.emojiMenu
      const newVal = val.slice(0, selStart) + emoji + val.slice(selEnd)
      this.SET_COMPOSER_INPUT({ context, value: newVal })
      this.CLOSE_TELEGRAM_MENUS()
      // 焦点回到输入框，光标停在刚插入的 emoji 之后；不然焦点还在弹窗里关掉的按钮上，连续输入断了
      this.$nextTick(() => {
        const ta = textareaId ? document.getElementById(textareaId) : null
        if (!ta) return
        ta.focus()
        // textarea selection 用 UTF-16 单位，跟 emoji.length 同口径（emoji 是代理对时是 2，组合序列更多）
        const pos = selStart + emoji.length
        ta.setSelectionRange(pos, pos)
      })
    },
    insertMention(name) {
      const { context, atStart, query, val, members, textareaId } = this.mentionMenu
      const member = members.find(m => m.name === name)
      const displayText = `@${name} `
      const newVal = val.slice(0, atStart) + displayText + val.slice(atStart + 1 + query.length)
      this.SET_COMPOSER_INPUT({ context, value: newVal })
      if (member) {
        this.ADD_PENDING_MENTION({ name, mention: { id: member.id, type: member.type || 'user', name: member.name } })
      }
      this.CLOSE_TELEGRAM_MENUS()
      this.$nextTick(() => {
        const ta = textareaId ? document.getElementById(textareaId) : null
        if (ta) {
          ta.focus()
          const cursorPos = atStart + displayText.length
          ta.setSelectionRange(cursorPos, cursorPos)
        }
      })
    },
    repositionMention() {
      const el = this.$refs.mentionEl
      if (!el) return
      const m = this.mentionMenu
      if (!m || m.anchorTop == null) return
      const actualH = el.offsetHeight
      this.mentionTop = Math.max(12, m.anchorTop - actualH - 8)
    },
    // 右键回复菜单 post-render 校正:用实际 offsetHeight 重算 top 让菜单"贴鼠标"
    // 优先下方展开(顶距点击 6px);空间不够时上方展开(底距点击 6px)
    repositionReplyMenu() {
      const el = this.$refs.replyMenuEl
      if (!el) return
      const actualH = el.offsetHeight
      const vh = window.innerHeight
      const anchorY = this.replyMenu.anchorY != null ? this.replyMenu.anchorY : this.replyMenu.y
      let top
      // 下方放得下 → 在点击下方 6px 展开
      if (anchorY + actualH + 6 + 12 <= vh) {
        top = anchorY + 6
      } else {
        // 下方放不下 → 上方展开,底部刚好在点击位置上 6px
        top = anchorY - actualH - 6
      }
      top = Math.max(12, Math.min(top, vh - actualH - 12))
      this.replyMenuTopCorrected = top
    },
    handleGlobalClick() { this.CLOSE_TELEGRAM_MENUS() },
    handleKeydown(e) { if (e.key === 'Escape') this.CLOSE_TELEGRAM_MENUS() },
    // 滚动时关菜单:菜单位置不会跟随滚动,留着会错位;capture 阶段才能捕到内部滚动容器(消息列表)
    handleGlobalScroll(e) {
      // 排除菜单自身内部滚动(emoji / mention 等可能滚)
      if (e.target && e.target.closest && e.target.closest('.telegram-popover-menu')) return
      this.CLOSE_TELEGRAM_MENUS()
    },
  },
  mounted() {
    document.addEventListener('click', this.handleGlobalClick)
    document.addEventListener('keydown', this.handleKeydown)
    // 用 capture 阶段 + passive 监听全局滚动,任意容器滚动都触发(消息列表 / 浏览器窗口 / iframe 等)
    window.addEventListener('scroll', this.handleGlobalScroll, { capture: true, passive: true })
    this._onOpenMM = () => this.openMemberManager()
    window.addEventListener('open-member-manager', this._onOpenMM)
    this.$nextTick(() => {
      const overlay = this.$refs.dismissOverlay
      if (overlay && overlay.parentNode !== document.body) {
        document.body.appendChild(overlay)
      }
    })
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleGlobalClick)
    document.removeEventListener('keydown', this.handleKeydown)
    window.removeEventListener('scroll', this.handleGlobalScroll, { capture: true })
    window.removeEventListener('open-member-manager', this._onOpenMM)
    const overlay = this.$refs.dismissOverlay
    if (overlay && overlay.parentNode === document.body) {
      document.body.removeChild(overlay)
    }
  }
}
</script>

<style scoped>
.telegram-menus-host {
  position: fixed; top: 0; left: 0; z-index: 200; pointer-events: none;
}
.telegram-menus-host > * { pointer-events: all; }
.telegram-mention-ai-tag {
  padding: 2px 6px; border-radius: 4px;
  background: rgba(90,110,255,0.12); color: #5a6eff;
  font-size: 10px; font-weight: 700; flex: 0 0 auto;
}

/* ── 群成员管理弹窗 ── */
.mm-overlay {
  position: fixed; inset: 0; z-index: 200;
  display: flex; align-items: center; justify-content: center;
  background: rgba(27,39,57,.26);
}
.mm-dialog {
  width: min(420px, calc(100vw - 32px)); max-height: 80vh;
  border-radius: 24px; background: rgba(255,255,255,.98);
  border: 1px solid rgba(71,97,128,.10);
  box-shadow: 0 24px 60px rgba(26,40,61,.22);
  display: flex; flex-direction: column; overflow: hidden;
  padding: 0;
}
.mm-dialog .group-dialog-head { min-height: 58px; padding: 0 18px; display: flex; align-items: center; justify-content: space-between; gap: 12px; border-bottom: 1px solid rgba(71,97,128,.06); }
.mm-dialog .group-dialog-search { margin: 12px 18px 8px; width: calc(100% - 36px); box-sizing: border-box; }
.mm-dialog .group-dialog-note { padding: 0 18px 8px; }
.mm-dialog .group-dialog-member-list { flex: 1; min-height: 0; overflow-y: auto; padding: 0 10px; }
.mm-foot { padding: 12px 18px; display: flex; justify-content: flex-end; border-top: 1px solid rgba(71,97,128,.06); }
.member-manager-actions { display: flex; align-items: center; gap: 6px; flex-shrink: 0; }
.member-manager-ai-tag {
  padding: 1px 6px; border-radius: 4px; font-size: 10px; font-weight: 800;
  background: rgba(91,141,239,.1); color: #5B8DEF;
}
.member-manager-owner-tag {
  padding: 1px 6px; border-radius: 4px; font-size: 10px; font-weight: 800;
  background: rgba(245,158,11,.1); color: #d97706;
}
.member-manager-remove-btn {
  background: rgba(239,68,68,.10) !important; color: #dc2626 !important; flex-shrink: 0;
}
.member-manager-remove-btn:hover { background: rgba(239,68,68,.18) !important; }

/* ── Forward Modal ── */
/* ── Forward dialog(对齐原型 forwardDialogOverlay) ── */
.forward-dialog-overlay { position: fixed; inset: 0; z-index: 400; display: none; }
.forward-dialog-overlay.open { display: block; }
/* 去掉 backdrop-filter:blur — 背景动画/滚动时它每帧重算后面内容,GPU 杀手;视觉差异极小 */
.forward-dialog-scrim { position: absolute; inset: 0; background: rgba(34,54,77,0.5); }
/* 弹窗本身上 will-change 让浏览器单独合成层,跟背景解耦 */
.forward-dialog { will-change: transform; contain: layout style; }
.forward-dialog { position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%); width: min(900px, calc(100vw - 32px)); height: min(640px, calc(100vh - 48px)); background: #fff; border-radius: 14px; box-shadow: 0 24px 60px rgba(34,54,77,0.28); display: grid; grid-template-columns: 348px 1fr; overflow: hidden; }
.forward-dialog-left { display: flex; flex-direction: column; border-right: 1px solid rgba(228,233,242,0.9); min-height: 0; }
.forward-dialog-search-wrap { padding: 14px 14px 8px; }
.forward-dialog-search { width: 100%; padding: 7px 12px 7px 32px; border-radius: 6px; border: 1px solid rgba(71,97,128,0.12); background: rgba(240,243,247,0.9) url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%238a9bb1' stroke-width='1.8'><circle cx='11' cy='11' r='7'/><path d='M20 20l-3.5-3.5' stroke-linecap='round'/></svg>") no-repeat 10px center / 14px 14px; font-size: 13px; outline: none; font-family: inherit; box-sizing: border-box; transition: border-color .15s ease, background-color .15s ease; }
.forward-dialog-search:focus { border-color: rgba(91,141,239,0.4); background-color: #fff; }
.forward-dialog-list { flex: 1; min-height: 0; overflow-y: auto; padding: 0 6px 12px; }
.forward-dialog-tabs { position: sticky; top: 0; z-index: 2; background: #fff; padding: 2px 4px 10px; }
.forward-dialog-tabs-inner { display: flex; gap: 2px; padding: 3px; background: rgba(241,244,250,.9); border-radius: 10px; }
.forward-dialog-tab { flex: 1; height: 30px; border: 0; border-radius: 7px; background: transparent; color: #7c8ca0; font-size: 12.5px; font-weight: 800; cursor: pointer; font-family: inherit; display: inline-flex; align-items: center; justify-content: center; transition: .15s; }
.forward-dialog-tab:hover:not(.is-active) { color: #5d7188; }
.forward-dialog-tab.is-active { background: #5B8DEF; color: #fff; }
.forward-dialog-topic-toggle { margin-left: auto; width: 24px; height: 24px; border: 0; background: transparent; color: #94a4b5; cursor: pointer; display: grid; place-items: center; flex-shrink: 0; border-radius: 6px; }
.forward-dialog-topic-toggle:hover { background: rgba(91,141,239,.08); color: #5B8DEF; }
/* 子项(二级 任务/话题)— spec 3.4:更深缩进 + L 形树枝连线 + 字号 12/600 + 复选圈缩到 15px */
.forward-dialog-subitem { padding: 4px 10px 4px 58px !important; min-height: 30px; position: relative; gap: 8px; }
.forward-dialog-subitem::before { content: ''; position: absolute; left: 38px; top: -4px; bottom: 50%; width: 12px; border-left: 1.5px solid rgba(171,183,202,.45); border-bottom: 1.5px solid rgba(171,183,202,.45); border-bottom-left-radius: 6px; pointer-events: none; }
.forward-dialog-subitem .forward-dialog-checkbox { width: 15px; height: 15px; }
.forward-dialog-subitem .forward-dialog-checkbox::after { width: 7px; height: 4px; transform: rotate(-45deg) translate(1px, -1px); }
.forward-dialog-subitem .forward-dialog-item-title { font-size: 12px; font-weight: 600; color: #5d7188; }
.forward-dialog-subitem.is-selected .forward-dialog-item-title { color: #22364d; font-weight: 700; }
.forward-dialog-item { display: flex; align-items: center; gap: 10px; padding: 7px 10px; border-radius: 6px; border: 0; background: transparent; cursor: pointer; text-align: left; transition: background .15s ease; width: 100%; box-sizing: border-box; }
.forward-dialog-item:hover { background: rgba(91,141,239,0.06); }
.forward-dialog-checkbox { width: 18px; height: 18px; border-radius: 50%; border: 1.5px solid rgba(171,183,202,0.6); background: #fff; flex: 0 0 auto; display: grid; place-items: center; transition: all .15s ease; }
.forward-dialog-item.is-selected .forward-dialog-checkbox { background: #35B58A; border-color: #35B58A; }
.forward-dialog-checkbox::after { content: ''; width: 8px; height: 5px; border-left: 2px solid #fff; border-bottom: 2px solid #fff; transform: rotate(-45deg) translate(1px, -1px); opacity: 0; transition: opacity .15s ease; }
.forward-dialog-item.is-selected .forward-dialog-checkbox::after { opacity: 1; }
.forward-dialog-item-avatar { width: 34px; height: 34px; border-radius: 50%; flex: 0 0 auto; background-size: cover; background-position: center; background-repeat: no-repeat; display: grid; place-items: center; color: #fff; font-size: 13px; font-weight: 800; }
.forward-dialog-item-copy { flex: 1; min-width: 0; display: grid; gap: 1px; }
.forward-dialog-item-title { font-size: 13px; font-weight: 700; color: #22364d; display: flex; align-items: center; gap: 6px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.forward-dialog-item-badge { font-size: 9px; font-weight: 800; padding: 1px 5px; border-radius: 999px; background: rgba(91,141,239,0.14); color: #3565b5; flex: 0 0 auto; }
.forward-dialog-item-badge.group { background: rgba(243,156,92,0.16); color: #b56c26; }
.forward-dialog-item-sub { font-size: 11px; color: #6f8398; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.forward-dialog-empty { padding: 24px 12px; text-align: center; color: #8a9bb1; font-size: 12px; }
.forward-dialog-right { display: flex; flex-direction: column; min-height: 0; padding: 16px 18px 14px; }
.forward-dialog-right-title { font-size: 13px; font-weight: 700; color: #22364d; margin-bottom: 8px; }
.forward-selected-list { flex: 1; min-height: 0; overflow-y: auto; display: grid; gap: 2px; align-content: start; margin: 0 -6px; padding: 0 6px; }
.forward-selected-item { display: flex; align-items: center; gap: 8px; padding: 6px 8px; border-radius: 6px; }
.forward-selected-item:hover { background: rgba(91,141,239,0.06); }
.forward-selected-item-avatar { width: 28px; height: 28px; border-radius: 50%; flex: 0 0 auto; background-size: cover; background-position: center; background-repeat: no-repeat; display: grid; place-items: center; color: #fff; font-size: 11px; font-weight: 800; }
.forward-selected-item-name { flex: 1; min-width: 0; font-size: 13px; color: #22364d; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.forward-selected-remove { width: 20px; height: 20px; border-radius: 50%; border: 0; background: rgba(171,183,202,0.2); color: #6f8398; cursor: pointer; display: inline-flex; align-items: center; justify-content: center; flex: 0 0 auto; transition: all .15s ease; padding: 0; line-height: 0; }
.forward-selected-remove svg { display: block; }
.forward-selected-remove:hover { background: rgba(224,93,93,0.14); color: #d55; }
.forward-selected-empty { flex: 1; padding: 20px 8px; text-align: center; color: #abb7ca; font-size: 12px; }
.forward-preview { margin-top: 10px; padding: 9px 12px; border-radius: 6px; background: rgba(240,243,247,0.8); font-size: 12px; color: #4a5f78; line-height: 1.5; max-height: 64px; overflow: hidden; display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical; text-overflow: ellipsis; }
.forward-preview-label { display: block; font-size: 10px; font-weight: 700; color: #8a9bb1; margin-bottom: 2px; }
.forward-note-wrap { margin-top: 8px; }
.forward-note-input { width: 100%; min-height: 54px; max-height: 90px; padding: 8px 10px; border-radius: 6px; border: 1px solid rgba(71,97,128,0.14); background: rgba(246,250,255,0.8); font-size: 13px; color: #22364d; resize: none; outline: none; font-family: inherit; box-sizing: border-box; transition: border-color .15s ease, background-color .15s ease; }
.forward-note-input:focus { border-color: rgba(91,141,239,0.4); background: #fff; }
.forward-note-input::placeholder { color: #abb7ca; }
.forward-dialog-actions { margin-top: 10px; display: flex; justify-content: flex-end; gap: 8px; }
.forward-dialog-btn { padding: 7px 20px; border-radius: 4px; border: 1px solid rgba(71,97,128,0.14); background: #fff; color: #4a5f78; font-size: 13px; font-weight: 700; cursor: pointer; font-family: inherit; transition: all .15s ease; }
.forward-dialog-btn:hover { background: rgba(240,243,247,0.9); }
/* 主按钮蓝色 — spec section 9 主色 #5B8DEF;选中复选圈才用绿色 #35B58A */
.forward-dialog-btn.primary { background: #5B8DEF; border-color: #5B8DEF; color: #fff; }
.forward-dialog-btn.primary:hover { background: #4a7de0; border-color: #4a7de0; }
.forward-dialog-btn.primary:disabled { background: rgba(91,141,239,0.4); border-color: rgba(91,141,239,0.4); cursor: not-allowed; }

</style>
